import { useEffect, useState } from "react";
import Seo from "@/components/Seo";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";

import { fetchBlog } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    fetchBlog().then((d) => setPosts(d.posts || [])).catch(console.error);
  }, []);

  return (
    <div className="py-16" data-testid="blog-page">
      <Seo path="/blog" />
      <div className="max-w-5xl mx-auto px-6">
        <span className="text-xs font-semibold uppercase tracking-wider text-[#002FA7]">Blog</span>
        <h1 className="font-display text-5xl sm:text-6xl font-bold text-ink mt-3 tracking-tight">
          Slim met je documenten.
        </h1>
        <p className="text-ink-soft text-lg mt-5 max-w-2xl">
          Updates over consumentenrecht, voorbeelden uit de praktijk, tips om beter te onderhandelen en uitleg per checker-type.
        </p>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {posts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group rounded-2xl bg-white border border-border overflow-hidden hover:shadow-lg transition-all hover:-translate-y-1"
              data-testid={`blog-card-${post.slug}`}
            >
              {post.image_url && (
                <img src={post.image_url} alt={post.title} className="w-full h-44 object-cover" />
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-ink-soft">
                  <Calendar className="h-3.5 w-3.5" />
                  {post.published_at?.slice(0, 10)}
                  <span>· {post.author || "CheckExpert"}</span>
                </div>
                <h2 className="font-display text-xl font-semibold text-ink mt-3">{post.title}</h2>
                <p className="text-sm text-ink-soft mt-2 leading-relaxed">{post.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-sm text-[#002FA7] font-semibold mt-4 group-hover:gap-2 transition-all">
                  Lees meer <ArrowRight className="h-4 w-4" />
                </span>
              </div>
            </Link>
          ))}
          {posts.length === 0 && (
            <p className="col-span-2 text-ink-soft">Nog geen blog-posts. Kom binnenkort terug.</p>
          )}
        </div>
      </div>
    </div>
  );
}
